import { ComponentType } from "react";
import { CompanyDocumentReadConfirmationSignedFileNameFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/** Имя подписанного ЭЦП файла, который участник вернул вместе с ознакомлением. */
export function CompanyDocumentReadConfirmationSignedFileName({
  data,
  whenEmpty,
}: {
  data?: Hidable<CompanyDocumentReadConfirmationSignedFileNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(confirmation) => <span>{confirmation.signedFile?.fileName}</span>}
    </Value>
  );
}
